// Called by :  src/components/question/Question.vue

<template>
    <video v-if="mode" :src="url" ref="rMov" type="video/mp4" class="qst_video h-100 w-auto" controls="controls" preload="auto" controlsList="nodownload" :title="getVideoName()" @error="onVideoError()">
      <p>mp4 video not supported</p>
    </video>
    <video v-else :src="url" ref="rMov" type="video/mp4" class="qst_video h-100 w-auto" controls="controls" preload="auto" controlsList="nodownload" :title="getVideoName()" @error="onVideoError()" onloadstart="f_onVideoLoad_v()" onended="f_onVideoEnded_v()">
      <p>mp4 video not supported</p>
    </video>
</template>

<script>
import { constants } from '@/constants'

export default {
  props: {
    url: String,
    mode: Boolean,
  },
  methods: {
    getVideoName() {
      if (this.params.isMediasTip) return f_getUrlFileName_s(this.url);
      return '';
    },
    onVideoError() {
      var oMov = this.$refs.rMov;
      var sSrc = constants.assets.movDefaultMp4File;
      oMov.setAttribute('src',sSrc);
    },
  },
  mounted: function() {
    // console.log('mounted-video-src', this.$refs.rMov.src);
    // document.getElementsByClassName("btn_page_submit")[0].disabled = true;
  },
  computed: {
    constants() {
      return constants
    },  
    params() {
      return this.$store.state.params
    },  
  },
}
</script>

<style scoped>
.qst_video {
  max-width: 100% !important;
  min-width: 20% !important;
  object-fit: contain !important;
}
</style>



// WEBPACK FOOTER //
// src/components/misc/VideoPlayer.vue